<nav class="lieferanten-sub-nav" mat-tab-nav-bar>
    <a
        mat-tab-link
        [routerLink]="['/lager/lieferanten']"
        [active]="isLieferantenStammActive()"
        >Lieferanten</a
    >
    <a
        #inst="routerLinkActive"
        *kienePermission="[17201]"
        mat-tab-link
        [routerLink]="['/lager/lieferanten/institutionen']"
        routerLinkActive
        [active]="inst.isActive"
        >Institutionen</a
    >
    <a
        #sk="routerLinkActive"
        *kienePermission="[17211]"
        mat-tab-link
        [routerLink]="['/lager/lieferanten/sonstige-kunden']"
        routerLinkActive
        [active]="sk.isActive"
        >Sonstige Kunden</a
    >
</nav>
<router-outlet></router-outlet>
